var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{class:_vm.className,attrs:{"src":_vm.src},on:{"load":_vm.onImageLoaded,"error":_vm.onImageError}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }